import React from 'react';
import NextPage from '../../assets/NextPage';
import PreviousPage from '../../assets/PreviousPage';
import Next from '../../assets/Next';
import Previous from '../../assets/Previous';

type Props = {
    pageSize: number;
    totalItems: number | undefined;
    currentPage: number;
    paginate: (pageNumber: number) => void;
    disableEdges?: boolean;
}

export default function Pagination({ pageSize, totalItems, currentPage, paginate, disableEdges = false }: Props) {
    const pageNumbers = [];
    const firstItemIndex = (currentPage - 1) * pageSize + 1;
    const lastItemIndex = Math.min(currentPage * pageSize, totalItems || 0);
    const maxPageButtons = 5;
    const lastPage = Math.max(1, Math.ceil((totalItems || 0) / pageSize));
    const isFirstPage = disableEdges && currentPage <= 1;
    const isLastPage = disableEdges && currentPage >= lastPage;

    if (totalItems !== undefined) {
        for (let i = 1; i <= Math.ceil(totalItems / pageSize); i++) {
            pageNumbers.push(i);
        }
    }

    let displayPageNumbers = pageNumbers;
    if (pageNumbers.length > maxPageButtons) {
        const minIndex = Math.max(currentPage - Math.floor(maxPageButtons / 2), 1);
        const maxIndex = Math.min(minIndex + maxPageButtons - 1, pageNumbers.length);

        if (maxIndex - minIndex < maxPageButtons - 1) {
            displayPageNumbers = pageNumbers.slice(-maxPageButtons);
        } else {
            displayPageNumbers = pageNumbers.slice(minIndex - 1, maxIndex);
        }
    }

    return (
        <nav>
            <ul className='pagination'>
                <li className={`page-item ${isFirstPage ? 'is-disabled' : ''}`}>
                    <a
                        href='!#'
                        className='page-link'
                        onClick={(e) => {
                            e.preventDefault();
                            if (isFirstPage) return;
                            paginate(1);
                        }}
                    >
                        {<PreviousPage/>}
                    </a>
                </li>

                <li className={`page-item ${isFirstPage ? 'is-disabled' : ''}`}>
                    <a
                        href='!#'
                        className='page-link'
                        onClick={(e) => {
                            e.preventDefault();
                            if (isFirstPage) return;
                            paginate(currentPage > 1 ? currentPage - 1 : 1);
                        }}
                    >
                        {<Next/>}
                    </a>
                </li>

                {displayPageNumbers.map(number => (
                    <li key={number} className={`page-item ${currentPage === number ? 'active' : ''}`}>
                        <a
                            href='!#'
                            className='page-link'
                            onClick={(e) => {
                                e.preventDefault();
                                paginate(number);
                            }}
                        >
                            {number}
                        </a>
                    </li>
                ))}

                <li className={`page-item ${isLastPage ? 'is-disabled' : ''}`}>
                    <a
                        href='!#'
                        className='page-link'
                        onClick={(e) => {
                            e.preventDefault();
                            if (isLastPage) return;
                            paginate(currentPage < pageNumbers.length ? currentPage + 1 : pageNumbers.length);
                        }}
                    >
                        {<Previous/>}
                    </a>
                </li>

                <li className={`page-item ${isLastPage ? 'is-disabled' : ''}`}>
                    <a
                        href='!#'
                        className='page-link'
                        onClick={(e) => {
                            e.preventDefault();
                            if (isLastPage) return;
                            paginate(pageNumbers.length);
                        }}
                    >
                        {<NextPage/>}
                    </a>
                </li>
            </ul>
            <div className='currently'>
                {totalItems != 0 ? (
                    `Currently displaying ${firstItemIndex}-${lastItemIndex} of ${totalItems}`
                ) : (
                    `Currently displaying 0 - ${lastItemIndex} of ${totalItems}`
                )}
            </div>
        </nav>
    );
}




